import { Component, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { Mission } from '@shared/entities/mission';
import { MissionFilter, MissionService } from '@shared/services/api/mission.service';
import { differenceInDays, sub } from 'date-fns';
import { BehaviorSubject, Observable, combineLatest, shareReplay, switchMap, tap } from 'rxjs';
import { ThemeService } from '../services/theme.service';

const DEFAULT_END_DATE = new Date().toISOString();
const DEFAULT_START_DATE = `${sub(new Date().toISOString(), { days: 365 }).toISOString()}`;

@Component({
  selector: 'app-machine-performances',
  templateUrl: './machine-performances.component.html',
  styleUrl: './machine-performances.component.scss'
})
export class MachinePerformancesComponent implements OnInit, OnChanges {
  private _serialNumberSubject = new BehaviorSubject<string>('');
  private _serialNumber$: Observable<string>;

  private _filtersSubject = new BehaviorSubject<MissionFilter>({});
  private _filters$: Observable<MissionFilter>;

  selectedFilterName = '';
  missions$!: Observable<Mission[]>;
  isLight = true;

  @Input() serialNumber?: string;

  constructor(private _missionService: MissionService, private _themeService: ThemeService) {
    this._serialNumber$ = this._serialNumberSubject.asObservable();
    this._filters$ = this._filtersSubject.asObservable();

    this.missions$ = combineLatest([this._serialNumber$, this._filters$]).pipe(
      switchMap(([serialNumber, currentFilters]) =>
        this._missionService.getByFilters({
          serialNumber,
          ...currentFilters
        } as MissionFilter)
      ),
      shareReplay(1)
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['serialNumber'] && this.serialNumber) {
      this._serialNumberSubject.next(this.serialNumber);
    }
  }

  ngOnInit() {
    this._filtersSubject.next({
      startDate: DEFAULT_START_DATE,
      endDate: DEFAULT_END_DATE,
      aggregation: 'DAY'
    });

    this._themeService.refresh$
      .pipe(switchMap(() => this._themeService.isDarkTheme$.pipe(tap((x) => (this.isLight = !x)))))
      .subscribe();
  }

  onSelectedFilter(filters: any[]) {
    if (this.serialNumber) {
      const filter = filters.pop();
      this.selectedFilterName = filter ? filter.text : '';

      if (filter) {
        const [endDate, startDate] = filter.selectedValue.split(' - ');
        this._filtersSubject.next({
          serialNumber: this.serialNumber,
          startDate,
          endDate,
          aggregation: differenceInDays(endDate, startDate) > 60 ? 'MONTH' : 'DAY'
        });
      } else {
        this._filtersSubject.next({
          startDate: DEFAULT_START_DATE,
          endDate: DEFAULT_END_DATE,
          aggregation: 'DAY'
        });
      }
    }
  }
}
